var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTriangleExclamation = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8125 13.0312L10.1562 1.65625C9.625 0.78125 8.34375 0.78125 7.84375 1.65625L1.15625 13.0312C0.65625 13.9062 1.28125 15 2.3125 15H15.6562C16.6875 15 17.3125 13.9062 16.8125 13.0312ZM8.25 5.25C8.25 4.84375 8.5625 4.5 9 4.5C9.40625 4.5 9.75 4.84375 9.75 5.25V9.25C9.75 9.6875 9.40625 10 9 10C8.625 10 8.25 9.6875 8.25 9.25V5.25ZM9 13C8.4375 13 8 12.5625 8 12.0312C8 11.5 8.4375 11.0625 9 11.0625C9.53125 11.0625 9.96875 11.5 9.96875 12.0312C9.96875 12.5625 9.53125 13 9 13Z",
    fill: "#EA032A"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTriangleExclamation);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxOCAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE2LjgxMjUgMTMuMDMxMkwxMC4xNTYyIDEuNjU2MjVDOS42MjUgMC43ODEyNSA4LjM0Mzc1IDAuNzgxMjUgNy44NDM3NSAxLjY1NjI1TDEuMTU2MjUgMTMuMDMxMkMwLjY1NjI1IDEzLjkwNjIgMS4yODEyNSAxNSAyLjMxMjUgMTVIMTUuNjU2MkMxNi42ODc1IDE1IDE3LjMxMjUgMTMuOTA2MiAxNi44MTI1IDEzLjAzMTJaTTguMjUgNS4yNUM4LjI1IDQuODQzNzUgOC41NjI1IDQuNSA5IDQuNUM5LjQwNjI1IDQuNSA5Ljc1IDQuODQzNzUgOS43NSA1LjI1VjkuMjVDOS43NSA5LjY4NzUgOS40MDYyNSAxMCA5IDEwQzguNjI1IDEwIDguMjUgOS42ODc1IDguMjUgOS4yNVY1LjI1Wk05IDEzQzguNDM3NSAxMyA4IDEyLjU2MjUgOCAxMi4wMzEyQzggMTEuNSA4LjQzNzUgMTEuMDYyNSA5IDExLjA2MjVDOS41MzEyNSAxMS4wNjI1IDkuOTY4NzUgMTEuNSA5Ljk2ODc1IDEyLjAzMTJDOS45Njg3NSAxMi41NjI1IDkuNTMxMjUgMTMgOSAxM1oiIGZpbGw9IiNFQTAzMkEiLz4KPC9zdmc+Cg==";